import { GameStateEnums } from '../../../../shared/GameEnums.ts';
import { setElementInnerText } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { TurnState } from '@colonist/game-states';
import FaviconNotification from '@static/images/favicon_notification.png';
export class UIWGameTabVisibilityController {
    onEvent(data, eventType) {
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.PlayerControllerStateUpdated:
            case GameStateEnums.UIGameEventEnums.TradeStateUpdated:
            case GameStateEnums.UIGameEventEnums.GameStateUpdated:
            case GameStateEnums.UIGameEventEnums.GameEnd:
                this.onStateUpdates();
                break;
            case GameStateEnums.UIGameEventEnums.ClientReconnectionTriggered:
                this.destroy();
                break;
            default:
                break;
        }
    }
    resetTabTitleAndFavIcon() {
        setElementInnerText(this.pageTitle, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: this.defaultTitle
            }
        });
        this.favicon.href = this.defaultFavIcon;
    }
    triggerActionNeededBlinking() {
        clearInterval(this.actionNeededBlinkInterval);
        if (this.isColonistTabHidden) {
            this.updateTabTitleAndFavIcon();
        } else {
            this.resetTabTitleAndFavIcon();
        }
        this.actionNeededBlinkInterval = setInterval(()=>this.isColonistTabHidden ? this.updateTabTitleAndFavIcon() : this.resetTabTitleAndFavIcon(), this.NOTIFICATION_BLINK_INTERVAL);
    }
    updateTabTitleAndFavIcon() {
        const actionNeededText = {
            key: 'strings:game.gameState.browserBlinkings.actionNeeded'
        };
        const secondText = this.isGameFinished ? {
            key: 'strings:game.gameState.turn.gameEndSelf'
        } : {
            key: 'strings:game.gameState.browserBlinkings.playersWaiting'
        };
        if (this.shouldDisplaySecondText) setElementInnerText(this.pageTitle, secondText);
        else setElementInnerText(this.pageTitle, actionNeededText);
        this.favicon.href = FaviconNotification;
        this.shouldDisplaySecondText = !this.shouldDisplaySecondText;
    }
    stopActionNeededBlinking() {
        if (this.actionNeededBlinkInterval == undefined) return;
        clearInterval(this.actionNeededBlinkInterval);
        this.resetTabTitleAndFavIcon();
    }
    onStateUpdates() {
        if (this.uiGameManager.gameController == undefined) return;
        const amITakingAction = this.uiGameManager.gameController.amITakingAction();
        this.isGameFinished = this.uiGameManager.gameController.currentState.turnState == TurnState.GameEnd;
        if (this.isGameFinished) this.uiGameManager.eventController.unregisterUIGameMechanic(this);
        const shouldStateUpdateTriggerBlinking = amITakingAction || this.isGameFinished;
        if (shouldStateUpdateTriggerBlinking) {
            this.triggerActionNeededBlinking();
        } else {
            this.stopActionNeededBlinking();
        }
    }
    onVisibilityChange() {
        if (this.uiGameManager.gameController == undefined) return;
        this.isColonistTabHidden = document.hidden == true;
        this.uiGameManager.gameStore.getState().gameClientConfig.setIsAppInBackground(document.hidden);
        if (this.isGameFinished) return this.stopActionNeededBlinking();
        const shouldVisibilityChangeTriggerBlinking = this.uiGameManager.gameController.amITakingAction() && !this.isGameFinished;
        if (shouldVisibilityChangeTriggerBlinking) {
            this.triggerActionNeededBlinking();
        } else {
            this.stopActionNeededBlinking();
        }
    }
    destroy() {
        document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    }
    constructor(uiGameManager){
        this.pageTitle = document.getElementById('browser_tab');
        this.favicon = document.getElementById('favicon');
        this.NOTIFICATION_BLINK_INTERVAL = 2000;
        this.isColonistTabHidden = false;
        this.shouldDisplaySecondText = true;
        this.isGameFinished = false;
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        if (uiGameManager.gameController.isReplay) return;
        if (uiGameManager.gameController.isBotGame()) return;
        this.uiGameManager = uiGameManager;
        this.defaultTitle = this.pageTitle.innerHTML;
        this.defaultFavIcon = this.favicon.href;
        uiGameManager.eventController.registerUIGameMechanic(this);
        this.visibilityChangeListener = ()=>this.onVisibilityChange();
        document.addEventListener('visibilitychange', this.visibilityChangeListener);
    }
}
